
import type { ReactNode } from "react";
import { TopNav } from "./TopNav";
import { BottomTabs } from "./BottomTabs";
import styles from "./AppShell.module.css";

interface NavItem {
  readonly href: string;
  readonly icon: ReactNode;
  readonly label: string;
}

interface AppShellProps {
  readonly navItems: readonly NavItem[];
  readonly activeHref: string;
  readonly userName: string;
  readonly onLogout: () => void;
  readonly children: ReactNode;
  readonly className?: string;
  readonly wide?: boolean;
  readonly showAdminLink?: boolean;
}

export function AppShell({
  navItems,
  activeHref,
  userName,
  onLogout,
  children,
  className,
  wide,
  showAdminLink = false,
}: AppShellProps) {
  return (
    <div className={`${styles.shell} ${className ?? ""}`}>
      <TopNav
        navItems={navItems}
        activeHref={activeHref}
        userName={userName}
        onLogout={onLogout}
        showAdminLink={showAdminLink}
      />
      <main className={styles.content}>
        <div className={wide ? styles.contentInnerWide : styles.contentInner}>
          {children}
        </div>
      </main>
      <BottomTabs navItems={navItems} activeHref={activeHref} />
    </div>
  );
}
